<template>
  <div class='question-breakdown' :style='{backgroundColor: computedBackgroundColour}'>
    <div class="question-breakdown--content" v-if='data'>
      <header>
        <div class="topline">
          <p class="small" :style='{color: computedTextColor, fontSize: computedTextFontSize + "%"}'>{{$t('We asked', 'weAsked', 'questionbreakdown')}}</p>
          <div :style='{fontSize: computedTitleFontSize + "%"}'>
            <h2 :style='{color: computedTitleColor}'>{{ $t(data.question, `${data.questionKey}.question`, 'questions' ) }}</h2>
          </div>
          <div v-if='hasAnswer && !hasMultipleAnswers'>
            <p class='small' :style='{color: computedTextColor, fontSize: computedTextFontSize + "%"}'>{{$t('Your response', 'yourResponse', 'questionbreakdown')}}:</p>
            <div :style='{fontSize: computedTitleFontSize + "%"}'>
              <h2 class='brand-text-color' :style='{color: computedChartSelectionColor}'>{{ $t(answerLabel(data.answer), `${answerIndex}.label`, `questions.${data.questionKey}.answers`) }}</h2>
            </div>
          </div>
          <div v-if='hasMultipleAnswers'>
            <p class='small' :style='{color: computedTextColor, fontSize: computedTextFontSize + "%"}'>{{$t('Your selection', 'yourResponse', 'questionbreakdown')}}:</p>
            <div :style='{fontSize: computedTitleFontSize + "%"}'>
              <h2 v-if='data.answer.length > 1' class='brand-text-color' :style='{color: computedChartSelectionColor}'>
                {{ $t('Multiple selections', 'multipleSelections', 'questionbreakdown')}}
              </h2>
              <h2 v-else-if='data.answer.length === 1' class='brand-text-color' :style='{color: computedChartSelectionColor}'>
                {{ $t(data.answer[0], data.answer[0], 'questionbreakdown')}}
              </h2>
              <h2 v-else class='brand-text-color' :style='{color: computedChartSelectionColor}'>
                {{ $t('Nothing selected', 'nothingSelected', 'questionbreakdown')}}
              </h2>
            </div>
          </div>
        </div>
        <div v-if='shouldShowCircle' class="agreement">
          <VueCircle :config='circleConfig' :progress='parseFloat(circlePercent)' :title='circleFigure'></VueCircle>
          <p class="helptext" v-if='!hasMultipleAnswers'>
            {{circleText}} {{$t('agreed with you', 'circleAgreed', 'questionbreakdown')}}
          </p>
          <p class="helptext" v-else>
            {{circleText}} {{$t('agreed with you on average across your selections', 'circleAgreedMultiple', 'questionbreakdown')}}
          </p>
        </div>
    </header>
      <hr>
      <div class='bars'>
        <div class='question' v-for='answer,i in data.answers' :key='`answer_${i}`'>
          <p class='small' :style='{color: computedTextColor, fontSize: computedTextFontSize + "%"}'>{{$t(answerLabel(answer),  `${i}.label`, `questions.${data.questionKey}.answers`)}}: <b>{{data.stats[answer].percent | decimalToPercent }}</b></p>
          <Progress :value='parseFloat(data.stats[answer].percent)' :color='progressColor(answer)'></Progress>
        </div>
      </div>
      <div v-if='editable'>
        <UIActions :buttons='["edit"]' @edit='onEdit'></UIActions>
      </div>
    </div>
  </div>
</template>
<script>
import Filters from '../../mixins/Filters';
import Progress from '../../Progress.vue';
import VueCircle from '../../Circle.vue';
import UIActions from './UIActions'
import TranslationMixin from '../lib/TranslationMixin'
export default {
  props: {
    data: {type: Object, default: () => {}},
    mini: {type: Boolean, default: false},
    circle: {type: Boolean, default: false},
    editable: {type: Boolean, default: false},
    translationContext: {type: String, default: null},
    config: {type: Object, default: function(){
      return {
        theme: {
          chartSelectionColor: null,
          backgroundColor: null,
          titleColor: null,
          textColor: null,
          titleFontSize: null,
          textFontSize: null
        }
      }
    }}
  },
  mixins: [Filters, TranslationMixin],
  components: {
    Progress,
    VueCircle,
    UIActions
  },
  created () {

  },
  inject: ['globalTheme'],
  computed: {
    hasAnswer () {
      return this.data.answer !== null && typeof this.data.answer !== 'undefined'
    },
    hasMultipleAnswers () {
      return this.hasAnswer && Array.isArray(this.data.answer)
    },
    answerIndex () {
      return this.data.answers.indexOf(this.data.answer)
    },
    shouldShowCircle () {
      return this.circle && this.hasAnswer
    },
    circlePercent () {
      return this.data.pc
    },
    circleFigure () {
      let result = this.data.pc
      return Math.round(result * 100, 2) + '%'
    },
    circleText () {
      let result = this.data.pc
      let nicePc = Math.round(result * 100, 2)
      return `${nicePc}%`
    },
    circleConfig () {
      return {backgroundStroke: '#dedede', stroke: this.computedChartSelectionColor, titleColor: this.computedChartSelectionColor}
    },
    computedBackgroundColour () {
      if (this.mini) {
        return null
      }
      return this.config.theme.backgroundColor || this.globalTheme.brandColor
    },
    computedTitleFontSize () {
      let fontSize = this.config.theme.titleFontSize  || this.globalTheme.titleFontSize
      if (!fontSize) {
        fontSize = 100
      }
      return fontSize
    },
    computedTextFontSize () {
      return this.config.theme.textFontSize || this.globalTheme.textFontSize
    },
    computedTitleColor () {
      if (this.mini) {
        return this.config.theme.titleColor
      }
      return this.config.theme.titleColor || this.globalTheme.brandTitleColor
    },
    computedTextColor () {
      if (this.mini) {
        return this.config.theme.textColor
      }
      return this.config.theme.textColor || this.globalTheme.brandTextColor
    },
    computedChartSelectionColor () {
      return this.config.theme.chartSelectionColor || this.globalTheme.chartSelectionColor
    }
  },
  data () {
    return {
      // circleConfig: {backgroundStroke: '#dedede', stroke: this.theme.circleColor, titleColor: this.theme.circleColor}
    }
  },
  methods: {
    answerLabel (answer) {
      if (this.data.type === 'checkbox') {
        return answer === true ? 'Yes' : 'No'
      }
      return answer
    },
    progressColor (answer) {
      if (this.data.answer === null || typeof this.data.answer == 'undefined' || this.data.answer === '') {
        return this.computedChartSelectionColor
      } else if (this.data.type === 'checkbox') {
        return this.data.answer === answer ? this.computedChartSelectionColor : '#cccccc'
      } else if (answer === this.data.answer || this.data.answer.indexOf(answer) !== -1) {
        return this.computedChartSelectionColor
      } else {
        return '#cccccc'
      }
    },
    onEdit () {
      this.$emit('edit', {target: this, fields: null, editorClass: 'QuestionBreakdownEditPanel'})
    }
  },
  watch: {
    config: {
      deep: true,
      handler (value) {
        this.$emit('change', value)
      }
    },
    data: {
      deep: true,
      handler (data) {
        if (typeof data === 'undefined') {
          return
        }
        this.stat = data.stats[data.answer]
      },
      immediate: true
    }
  }
}
</script>
<style lang='scss'>
  .report.light {
    .question-breakdown {
      .progress-bar {
        background-color: #efefef;
      }
    }
  }
  .report.dark {
    .question-breakdown {
      .progress-bar {
        background-color: #333;
      }
    }
  }
</style>

<style lang='scss' scoped>
  .question-breakdown {
    position: relative;
    header {
      display: flex;
    }
    .topline {
      flex: 1 1 64%;
      padding-right:5%;
      .small {
        margin-bottom: 5px;
      }
      h2 {
        font-size: 110%;
        font-weight: bold;
        @media (min-width: 768px) {
          font-size: 150%;
        }
        @media (min-width: 768px) {
          font-size: 250%;
        }
      }
    }
    .agreement {
      flex: 0 1 22%;
      p.helptext {
        text-align: center;
        font-size: 90%;
      }
    }

    @media (max-width: 480px) {
        header {
          flex-direction: column;
        }
        .topline {
          order: 2;
        }
        .agreement {
          order: 1;
          width: 45%;
          margin: 0 auto 1rem;
        }
    }

    hr {
      border-color: #ccc;
      margin-bottom: 1rem;
    }
    p {
      margin:0;
    }
    p.small {
      font-size: 90%;
    }
    h2 {
      margin-top: 0;
    }
    .progress-bar {
      margin: 10px 0;
    }

    .bars {
      margin-bottom: 1rem;
    }
    @media (min-width: 768px) {
      h2 {
        font-size: 3vw;
        font-weight: bold;
      }
      p {
        margin-bottom: 0.5rem;
      }
      .bars {
        padding: 0;
      }
      .question {
        margin-bottom: 2rem;
      }
      .progress-bar {
        margin: 10px 0;
        height: 10px;
      }
    }
    @media (min-width: 920px) {
      h2 {
        font-size: 4vw;
      }
    }
    @media (min-width: 1200px) {
      h2 {
        font-size: 3vw;
      }
    }

    &.mini {
      .bars {
        .question {
          margin-bottom:0;
        }
      }
      .progress-bar {
        margin: 10px 0;
        height: 5px;
      }
    }

  }
</style>